var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FC6B21;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,32.3c4.8,0,8.7-3.9,8.7-8.7c0-4.8-3.9-8.7-8.7-8.7c-4.8,0-8.7,3.9-8.7,8.7C23.3,28.4,27.2,32.3,32,32.3z  M32,21.2c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4C29.6,22.3,30.7,21.2,32,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.9,41.6c4-5.1,7.8-12,7.8-18.3C54.6,11,44.5,1,32,1C19.5,1,9.4,11,9.4,23.3c0,6.3,3.7,13.2,7.8,18.3 c-6.1,1.4-13.3,4.2-13.3,9.9C3.8,59.4,18.4,63,32,63s28.2-3.6,28.2-11.5C60.2,45.8,52.9,42.9,46.9,41.6z M32,7.3 c9,0,16.4,7.2,16.4,16c0,4.8-3.7,12-9,17.4c-3.3,3.4-6.1,4.9-7.3,4.9s-4.1-1.5-7.3-4.9c-5.3-5.4-9-12.6-9-17.4 C15.6,14.5,23,7.3,32,7.3z M32,56.7c-14.1,0-21.5-3.8-21.9-5.2c0.2-0.8,3.6-3.3,12.1-4.6c2.6,2.3,6.3,4.8,9.8,4.8 c3.5,0,7.2-2.5,9.8-4.8c8.5,1.3,11.9,3.7,12.1,4.4C53.5,52.9,46.1,56.7,32,56.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCircle);
export default __webpack_public_path__ + "static/media/location-circle.17ca0131fffc0772fe41d395b2004fc7.svg";
export { ForwardRef as ReactComponent };